function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import './index.scss';
import 'js-events';
import turbolinks from 'turbolinks';
import ujs from '@rails/ujs';
import { sendRequest, decodeUrlQueryString } from 'js-api';
import { resetScrollingRetention } from 'scrolling-retainer';
import Popover from 'popover';
export function start() {
  prepareTurbolinks();
  ujs.start();
  document.addEventListener('jsapi:requestend', jsapiRequestEnded);
  document.addEventListener('turbolinks:load', turbolinksLoaded);
  document.addEventListener('turbolinks:click', turbolinksClicked);
  document.addEventListener('turbolinks:before-visit', turbolinksBeforeVisit);
  document.addEventListener('turbolinks:request-start', turbolinksRequestStarted);
  document.addEventListener('turbolinks:request-end', turbolinksRequestEnded);
  document.addEventListener('turboujs:load', function (_event) {
    addPopoverClickEvents(document);
  });
  document.addEventListener('ajax:beforeSend', setupFormSubmission);
  document.addEventListener('ajax:complete', completeFormSubmission);
} ////////// Popover Links

export function addPopoverClickEvents(element) {
  element.querySelectorAll('[data-turbolinks-action="popover"]').forEach(function (link) {
    return link.addEventListener('click', popoverLinkClicked);
  });
}

function popoverLinkClicked(event) {
  if (event.metaKey || event.ctrlKey) {
    return true;
  }

  event.preventDefault();
  var url = this.href;
  var cancelled = !document.triggerEvent('turboujs:navigate', {
    url: url,
    action: 'popover',
    mobileAction: 'popover'
  });

  if (cancelled) {
    return;
  }

  var popover = new Popover({
    removeOnHide: true
  });
  popover.loadContent(url);
  popover.show();
} ////////// Replace Page


export function replacePageXHR(xhr, options) {
  var contentType = xhr.getResponseHeader('Content-Type');

  if (!contentType) {
    if (options.popover) {
      options.popover.hide();
    }

    return;
  }

  if (contentType.match(/javascript/)) {// return
  } else if (contentType.startsWith('text/html')) {
    if (options.popover) {
      var htmlElement = document.createElement('html');
      htmlElement.innerHTML = xhr.responseText;
      options.popover.displayContent(htmlElement, xhr);
    } else {
      var _turbolinks = window.Turbolinks;
      var controller = _turbolinks.controller;

      if (controller.currentVisit) {
        controller.currentVisit.cancel();
      }

      var snapshot = _turbolinks.Snapshot.fromHTMLString(xhr.responseText);

      var turboLocation = xhr.getResponseHeader('Turbolinks-Location');
      var turboAction = 'restore';

      var location = _turbolinks.Location.wrap(turboLocation);

      var visit = new _turbolinks.Visit(controller, location, turboAction);
      visit.historyChanged = false;
      visit.referrer = controller.location;

      visit.getCachedSnapshot = function () {
        return snapshot;
      };

      controller.currentVisit = visit;
      controller.currentVisit.start();
      controller.notifyApplicationAfterVisitingLocation(location);
    }
  } else if (contentType.startsWith('application/x-download')) {
    var url = turbolinks.Location.wrap(xhr.response);
    var filename = url.getLastPathComponent();
    var contentDisposition = xhr.getResponseHeader('Content-Disposition');

    if (contentDisposition) {
      var captures = contentDisposition.match(/filename="(.*?\.[a-z]+)"/);

      if (captures) {
        filename = captures[1];
      }
    }

    var cancelled = !document.triggerEvent('turboujs:download', {
      url: url.toString(),
      filename: filename
    });

    if (cancelled) {
      return;
    }

    if (options.popover) {
      setTimeout(function () {
        return options.popover.hide();
      }, 500);
    } else {
      if (typeof options.target.hideSubmission === 'function') {
        options.target.hideSubmission();
      }
    }

    window.location.href = url;
  }
} ////////// JS-API Events

function jsapiRequestEnded(event) {
  var response = event.detail[0];
  var xhr = response._xhr;
  var requestParams = event.detail[1];
  var requestOptions = requestParams[2];

  var retryCallback = function retryCallback() {
    sendRequest.apply(void 0, _toConsumableArray(requestParams)).then(requestOptions.resolve);
  };

  var cancelCallback = function cancelCallback() {
    requestOptions.resolve(response);
  };

  var cancelled = !document.triggerEvent('turboujs:requestend', [xhr, retryCallback, cancelCallback]);

  if (cancelled) {
    event.preventDefault();
  }
} ////////// Turbolinks Events


function prepareTurbolinks() {
  turbolinks.start();
  turbolinks._originalVisit = turbolinks.visit;
  turbolinks.visit = turbolinksVisit;
  turbolinks.controller.adapter._visitRequestFailedWithStatusCode = turbolinks.controller.adapter.visitRequestFailedWithStatusCode;

  turbolinks.controller.adapter.visitRequestFailedWithStatusCode = function (visit, statusCode) {
    if (visit.turboujsRenderAborted) {
      return;
    }

    this._visitRequestFailedWithStatusCode(visit, statusCode);
  };
}

function turbolinksVisit(location, options) {
  var action = null;
  var mobileAction = null;

  if (options) {
    action = options.action;
    mobileAction = options.mobileAction;
  }

  var url = turbolinks.Location.wrap(location);
  var cancelled = !document.triggerEvent('turboujs:navigate', {
    url: url,
    action: action,
    mobileAction: mobileAction
  });

  if (!cancelled) {
    turbolinks._originalVisit(location, options);
  }
}

export function turbolinksWebviewVisit(location, options) {
  turbolinks._originalVisit(location, options);
} // Cancelling the `turbolinks:click` event causes turbolinks to allow the event to fall through to the browser. The
// event needs to be prevented from `turbolinks:before-visit`, however we need access to the original target for
// properties.

var _turbolinksClickData = {};

function turbolinksClicked(event) {
  var action = event.target.getAttribute('data-turbolinks-action');
  var mobileAction = event.target.getAttribute('data-turbolinks-mobile-action');
  var cancelled = !document.triggerEvent('turboujs:navigate', {
    url: event.data.url,
    action: action,
    mobileAction: mobileAction
  });
  _turbolinksClickData = {
    url: event.data.url,
    action: action,
    mobileAction: mobileAction,
    cancelled: cancelled
  };
}

function turbolinksBeforeVisit(event) {
  if (event.data.url === _turbolinksClickData.url) {
    if (_turbolinksClickData.cancelled) {
      event.preventDefault();
    }
  }

  _turbolinksClickData = {};
}

function turbolinksLoaded(_event) {
  document.triggerEvent('turboujs:load');
  document.triggerEvent('turboujs:loadend');
  resetScrollingRetention();
}

function turbolinksRequestStarted(_event) {
  document.triggerEvent('turboujs:loadstart');
}

function turbolinksRequestEnded(event) {
  var xhr = event.data.xhr;
  var url = event.data.url;

  var retryCallback = function retryCallback() {
    turbolinks.visit(url, {
      action: 'replace'
    });
  };

  var cancelCallback = function cancelCallback() {
    window.history.back();
  };

  var cancelled = !document.triggerEvent('turboujs:requestend', [xhr, retryCallback, cancelCallback]);

  if (cancelled) {
    var visit = turbolinks.controller.currentVisit;
    visit.turboujsRenderAborted = true;
    visit.request.cancel();
    document.triggerEvent('turboujs:loadend');
  }
} ////////// Form Events


HTMLFormElement.prototype.buttonForQuery = function (query) {
  var buttons = this.querySelectorAll('button[type=submit]');
  var button;

  if (buttons.length === 1 || !query) {
    button = buttons[0];
  } else if (buttons.length > 1) {
    var data = decodeUrlQueryString(query);
    buttons.forEach(function (b) {
      if (data[b.name] === b.value) {
        button = b;
      }
    });
  }

  return button;
};

function setupFormSubmission(event) {
  var xhr = event.detail[0];
  xhr.turboujs = true;
  var options = event.detail[1];
  xhr.turboujsOptions = options;
  var form = event.target;
  if (form.nodeName !== 'FORM' || form.getAttribute('data-remote') !== 'true') return;
  var cancelled = !document.triggerEvent('turboujs:setupform', [xhr, options, form]);

  if (cancelled) {
    event.preventDefault();
    return false;
  }

  xhr.setRequestHeader('X-Unobtrusive-Form', 'true');
  var popover = form.closest('pop-over');

  if (popover !== null) {
    xhr.setRequestHeader('X-Application-Layout', 'popover');
  }
}

function completeFormSubmission(event) {
  var target = event.target;
  var xhr = event.detail[0];

  if (target.getAttribute('data-remote') !== 'true') {
    return;
  }

  if (target.nodeName === 'FORM') {
    document.triggerEvent('turboujs:formcomplete', [xhr, target]);
  }

  var retryCallback = function retryCallback() {
    if (target.nodeName === 'FORM') {
      if (!target.closest('body')) {
        target.style.display = 'none';
        var popover = document.querySelector('pop-over');

        if (popover) {
          popover.append(target);
        } else {
          document.body.append(target);
        }
      }

      var button = target.buttonForQuery(xhr.turboujsOptions.data);
      button.focus();
      button.click();
    } else {
      target.click();
    }
  };

  var cancelCallback = function cancelCallback() {};

  var proceed = document.triggerEvent('turboujs:requestend', [xhr, retryCallback, cancelCallback]);

  if (proceed) {
    var popover = target.closest('pop-over');
    replacePageXHR(xhr, {
      target: target,
      popover: popover
    });
  } else {
    document.triggerEvent('turboujs:formcanceled', [xhr, target]);
  }
}